/**
 * Per,
 * https://docs.coveo.com/en/105/cloud-v2-developers/api-key-authentication
 * an API token meant to be stored client-side and only has permission
 * to execute queries.
 *
 */
import { v4 as uuidv4 } from 'uuid';

const getAPIToken = () => process.env.ANALYTICS_API_KEY;

const getAnalyticsEndpoint = () => process.env.ANALYTICS_ENDPOINT;

const getOrganizationId = () => process.env.COVEO_ORG_ID;

const pageId = uuidv4();

const hasSearchContext = (searchUid, vistorid) => (
  vistorid !== null
  && vistorid !== undefined
  && searchUid !== null
  && searchUid !== undefined
);

const coveoUaClick = async (href = '', displayText = '', searchUid = 0, permanentid = 0, vistorid = 0) => {
  if (!hasSearchContext(searchUid, vistorid)) {
    return null;
  }

  return fetch(`${getAnalyticsEndpoint()}/v15/analytics/collect`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${getAPIToken()}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      "v": "1",
      "tid": getOrganizationId(),
      "t": "event",
      "pid": pageId,
      "dl": href,
      "dr": typeof window !== 'undefined' ? window.location.href : '',
      "dt": displayText,
      "tm": Date.now(),
      "ul": "en-US",
      "ua": typeof navigator !== 'undefined' ? navigator.userAgent : '',
      "cid": vistorid,
      "uid": "anonymous",
      "searchHub": "customer-education",
      "tab": "customer-education",
      "trackingId": "customer-education",
      "contentIdKey": "permanentid",
      "contentId": permanentid,
      "pa": "click",
      "pal": `coveo:search:${searchUid}`,
      "ec": "search",
      "ea": "documentOpen",
      "custom": JSON.stringify({
        "documentPosition": 2,
        "sourceName": "customer-education"
      })
    })
  });
};

export const coveoUaRightClick = async (
  href = '',
  displayText = '',
  searchUid = 0,
  permanentid = 0,
  vistorid = 0
) => {
  if (!hasSearchContext(searchUid, vistorid)) {
    return null;
  }

  return fetch(`${getAnalyticsEndpoint()}/v15/analytics/click`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${getAPIToken()}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      "anonymous": true,
      "clientId": vistorid,
      "actionCause": "documentOpen",
      "documentPosition": 2,
      "documentTitle": displayText,
      "documentUrl": href,
      "language": "en-US",
      "originLevel1": "customer-education",
      "originLevel2": "customer-education",
      "searchQueryUid": searchUid,
      "sourceName": "customer-education",
      "userAgent": typeof navigator !== 'undefined' ? navigator.userAgent : '',
      "customData": {
        "contentIDKey": "permanentid",
        "contentIDValue": permanentid
      }
    })
  });
};

export default coveoUaClick;
